interface FilterQueryTriplePlay {
  category: string;
  name: string;
  value: any;
}

export const defaultFiltersTriplePlay: FilterQueryTriplePlay[] = [
  {
    category: 'general',
    name: 'productTypes',
    value: 'Television, Internet, Call',
  },
  {
    category: 'general',
    name: 'isMove',
    value: 'true',
  },
];
